import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const carouselControlsFn = /* @__PURE__ */ createRecipe('carousel-controls', {}, [])

const carouselControlsVariantMap = {}

const carouselControlsVariantKeys = Object.keys(carouselControlsVariantMap)

export const carouselControls = /* @__PURE__ */ Object.assign(memo(carouselControlsFn.recipeFn), {
  __recipe__: true,
  __name__: 'carouselControls',
  __getCompoundVariantCss__: carouselControlsFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: carouselControlsVariantKeys,
  variantMap: carouselControlsVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, carouselControlsVariantKeys)
  },
  getVariantProps: carouselControlsFn.getVariantProps,
})